import { Navbar } from '@/components/Navbar';
import React, { useEffect } from 'react';
import { toast, Toaster } from 'sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { usePage } from '@inertiajs/react';

interface LayoutProps {
  children: React.ReactNode;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});
export default function Layout({ children }: LayoutProps) {
  const { flash } = usePage<{ flash: { alert?: string; notice?: string } }>()
    .props;
  // const { url } = usePage();

  // const hideNavbarPaths = [
  //   '/session/new', // Login
  //   '/registration/new', // Signup
  //   '/passwords/new', // Forgot password
  //   '/passwords/edit', // Reset password
  // ];

  // const shouldHideNavbar = hideNavbarPaths.some((path) => url.startsWith(path));

  useEffect(() => {
    if (flash?.notice) toast.success(flash.notice);
    if (flash?.alert) toast.error(flash.alert);
  }, [flash]);
  return (
    <QueryClientProvider client={queryClient}>
      <div className="flex flex-col h-full">
        <Toaster richColors position="top-center" />
        {/* {!shouldHideNavbar && <Navbar />} */}
        <Navbar />
        <main className="flex-1">{children}</main>
        <ReactQueryDevtools initialIsOpen={false} />
      </div>
    </QueryClientProvider>
  );
}
